import { Outlet } from "react-router-dom"
import { SideBar } from "./SideBar"

export const AdminLayout = () => {


    return (
        <div className="md:flex bg-blue-50">
            <SideBar />
            <div className="md:w-[calc(100%-256px)] w-full h-max p-4">
                <Outlet />
            </div>
        </div>
    )
}